export default {
  login: {
    passwordResetSentAlertLabel:
      'Das hat geklappt! Bitte überprüfe Deine E-Mails und folge den Anweisungen.',
    title: 'Wir melden Dich an...',
    button: 'Anmelden',
    form: {
      email: 'Deine E-Mail Adresse',
      password: 'Dein Passwort',
    },

    message: {
      success: 'Super. Du wurdest erfolgreich angemeldet.',
      error: 'Ups, es gab einen Fehler. Bitte versuche es noch einmal.',
    },

    forgotPassword: {
      title: 'Passwort zurücksetzen',
      button: 'Passwort vergessen?',
      form: {
        email: 'E-Mail',
        submitButton: 'Passwort zurücksetzen',
        password: 'Neues Passwort',
        passwordConfirmation: 'Passwort bestätigen',
      },
      passwordResetSent:
        'Wir haben Dir eine E-Mail gesendet. Bitte überprüfe Dein Postfach.',
      formSuccessMessage: 'Dein Passwort wurde erfolgreich zurückgesetzt.',
      invalidLink:
        'Ungültiger oder abgelaufener Link zum Zurücksetzen des Passworts.',
      userNotFound: 'Benutzer nicht gefunden.',
    },
    emailAlreadyExists:
      'Du hast schon ein Konto. {login} für schnelleren Checkout und Bestellübersicht. Oder als Gast fortfahren.',
    emailAlreadyExistsLogin: 'Hier einloggen',
    validation: {
      email: 'Bitte gib eine gültige E-Mail-Adresse ein',
      min: 'Muss mindestens {min} Zeichen lang sein',
      passwordMismatch: 'Passwörter stimmen nicht überein',
      required: 'Dieses Feld ist erforderlich',
    },
  },
}
